import * as React from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import {
    Box,
    Stack, Typography
} from '@mui/material';
const CustomSlider = styled(Slider)(({ theme }) => ({
    // Customize the track
    '& .MuiSlider-track': {
        display:'none'
    },
    // Customize the thumb


    '& .MuiSlider-rail': {
        width:'107%',
        height: 25,
        opacity: 1,
        backgroundColor: '#196000',
        backgroundImage: 'linear-gradient(90deg, #196000 0%, #FAFF00 50%, #FF0000 100%)',
        transform: 'translate(-3.5%, -50%)',
        '-web-kit-transform': 'translate(-3.5%, -50%)'
    }
}));

interface Props {
    value : number;
}

const CrimeMeterSlider : React.FC<Props> = ({ value }) => {
    value = Math.round(value)
    return (
        <Stack sx={{}}>
            <CustomSlider
                defaultValue={value}
                disabled // Make it non-interactive
                sx={{
                    width: 300,
                    '& .MuiSlider-thumb': {
                        backgroundColor: '#FFF',
                        width: 22,
                        height: 22,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        color: '#000',
                        '&::before': {
                            content: `'${value}'`,
                            display: 'flex',
                            'align-items': 'center',
                            'justify-content': 'center'
                        },
                    },
                }}
            />
            <Box sx={{display:'flex',flexDirection:'row', justifyContent:'space-between'}}>
                <Typography fontSize={14} ml={'-9px'}>
                    Low Crime
                </Typography>
                <Typography fontSize={14} mr={'-9px'}>
                    High Crime
                </Typography>
            </Box>
        </Stack>

    );
}

export default CrimeMeterSlider;